import { User_Role } from '@occc/graphql';

import { AccessControlMatrix } from './access-control-context';
import { Feature } from './types';

const siteManagementFeatures = [
  Feature.LOCATIONS_VIEW,
  Feature.LOCATION_VIEW,
  Feature.LOCATION_CREATE,
  Feature.LOCATION_EDIT,
];

export const liteVersionAccessControlMatrix: AccessControlMatrix = [
  [
    User_Role.Admin,
    null,
    [
      ...siteManagementFeatures,
      Feature.USER_MANAGEMENT_CREATE,
      Feature.USER_MANAGEMENT_EDIT,
      Feature.USER_MANAGEMENT_VIEW,
      Feature.TRANSACTIONS_VIEW,
      Feature.TRANSACTION_VIEW,
    ],
  ],
  [User_Role.Sitetech, null, siteManagementFeatures],
];
